import { Grid, Typography } from '@material-ui/core';
import React from 'react';

import { Booking, helpers } from '@aps-management/primapp-common';

import i18n from '_utils/i18n';

const Header = ({ date, time = null, course, playersCount, accessoriesCount, rightComponent = null }) => {
  const courseName = `${i18n.t(`terms.course_type_${course.type}`)} "${course.name}"`;
  const formattedDate = helpers.string.ucfirst(i18n.l('date.formats.long_y', new Date(date)));
  const details = `${i18n.t('terms.players', { count: playersCount })} • ${i18n.t('terms.rentals', { count: accessoriesCount })}`;

  const formattedTime = time && Booking.functions.formatTime(time);

  return (
    <Grid container spacing={24} justify='center' style={{ marginBottom: 16 }}>
      <Grid item>
        <Typography variant='h5' align='center' component='h2'>
          {formattedDate} {formattedTime ? `• ${formattedTime}` : ''}
        </Typography>
        <Typography variant='h6' component='p' align='center' color='textSecondary'>
          {courseName}
        </Typography>
        <Typography component='p' align='center' variant='body1'>
          {details}
        </Typography>
      </Grid>
      {rightComponent && <Grid item>{rightComponent}</Grid>}
    </Grid>
  );
};

export default Header;
